import { DMEData, generalSettings, registerWidget } from "dmeditor";
import { Latest } from "./Latest";

export default () => {
  registerWidget(
    {
      type: "mf-latest",
      icon: "matchfit",
      name: "Latest schools",
      category: "basic",
      settings: [
        { name: "Days", settingComponent: "number", property: ".limit" },
        { name: "Location", settingComponent: "input", property: ".location" },
        {
          name: "Location name",
          settingComponent: "input",
          property: ".locationName",
        },
        ...generalSettings,
      ],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "mf-latest",
            data: { limit: 10 },
            children: [],
          };
        },
      },
    },
    {
      render: Latest,
    }
  );
};
